import { Button, Progress, dialog } from "nq-component";
import CardView from "../../../../components/common/CardView";
import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import Table from "../../../../components/Table";
import { FloatingForm } from "../../../../components/common/Converter";
import InputFactory from "../../../../components/InputFactory";
import BiometricDevicesPresenter from "./BiometricDevicesPresenter";

export default class BiometricDevices extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new BiometricDevicesPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      yearSelected: "",
      periodSelected: "",
      bioData: props.bioData,
      objects: [],
      selectModal: false,
      count: 0,
      limit: 50,
      current: 1,
      serialNumber: [],
      referenceSN: [],
    };
  }

  componentDidMount() {
    this.presenter.componentDidMount();
    const serialNum = this.props.bioData.serialNum || [];
    this.setState({
      bioData: { ...this.props.bioData, serialNum, removedSN: [] },
      serialNumber: serialNum,
      referenceSN: serialNum,
    });
  }

  getCollectionName() {
    return "biometric_devices";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleAssignBiometrics = (object) => {
    const sn = object.id;

    this.setState((prevState, props) => {
      const prevBio = (prevState.bioData ?? props.bioData) || {};
      const prevSerials = Array.isArray(prevBio.serialNum)
        ? prevBio.serialNum
        : [];
      const prevRemoved = Array.isArray(prevBio.removedSN)
        ? prevBio.removedSN
        : [];
      const refSN = Array.isArray(prevState.referenceSN)
        ? prevState.referenceSN
        : [];
      const prevSel = Array.isArray(prevState.serialNumber)
        ? prevState.serialNumber
        : [];

      let nextSerials = [...prevSerials];
      let nextRemoved = [...prevRemoved];

      const inSerial = nextSerials.includes(sn);
      const wasOriginallyAssigned = refSN.includes(sn);

      if (inSerial) {
        // UNCHECKING - remove from serialNum
        nextSerials = nextSerials.filter((x) => x !== sn);

        // If it was originally assigned, add to removedSN
        if (wasOriginallyAssigned && !nextRemoved.includes(sn)) {
          nextRemoved.push(sn);
        }
      } else {
        // CHECKING - add to serialNum
        nextSerials.push(sn);

        // If it was originally assigned and we're re-adding, remove from removedSN
        if (wasOriginallyAssigned) {
          nextRemoved = nextRemoved.filter((x) => x !== sn);
        }
      }

      const selectedHas = prevSel.includes(sn);
      const nextSelected = selectedHas
        ? prevSel.filter((x) => x !== sn)
        : [...prevSel, sn];

      const nextBio = {
        ...prevBio,
        serialNum: nextSerials,
        removedSN: nextRemoved,
      };

      return {
        bioData: nextBio,
        serialNumber: nextSelected,
        removedSN: nextRemoved,
      };
    });
  };

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, limit, current } = this.state;
    if (!schema) return <Progress />;
    // console.log("BIO: ", this.state.bioData);
    return (
      <>
        <>
          <FloatingForm width="80rem">
            <CardView style={{ padding: 0 }}>
              <h4 className="fs-6 fw-bold pt-3 ps-3">Assign Biometrics</h4>
              <hr />
              <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
                <h4 className="d-flex align-items-center pb-4">
                  <span
                    className="d-flex justify-content-center align-items-center me-2 rounded text-white"
                    style={{
                      width: "3rem",
                      height: "3rem",
                      fontSize: "1.5rem",
                      backgroundColor: "#ccc",
                    }}
                  >
                    {this.props.bioData.username.substring(0, 2).toUpperCase()}
                  </span>
                  <strong>{this.props.bioData.username}</strong>
                </h4>

                <CardView className="mb-3">
                  <div className="d-flex align-items-center gap-3">
                    <div className="d-flex gap-2">
                      {Object.keys(schema.filters || {}).map((field) => {
                        let { type, ...options } = schema.filters[field];
                        return (
                          <div className="d-flex" key={field}>
                            <InputFactory
                              key={field}
                              type={type}
                              field={field}
                              where={{}}
                              onChange={this.onChangeFilter.bind(this, type)}
                              {...options}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </CardView>

                <Table
                  // objectData={this.handleClickOk.bind(this)}
                  objectData={(object) =>
                    // console.log("OBJ: ", objects);
                    this.handleAssignBiometrics(object)
                  }
                  empPointer={this.state.serialNumber}
                  progress={loading}
                  //   refetch={this.refetchData.bind(this)}
                  fields={schema.fields}
                  objects={objects}
                  collection={schema}
                  count={count}
                  limit={limit}
                  current={current}
                  loadPagination={this.onClickPagination.bind(this)}
                  actionsList={[
                    {
                      label: <i></i>,
                      actionType: "assignBio",
                    },
                  ]}
                  // selectable
                  // collapsable
                  excludeFields={Object.keys(schema.fields).reduce(
                    (acc, key) => {
                      const options = schema.fields[key];
                      if (options.read === false) {
                        acc.push(key);
                      }
                      switch (options._type || options.type) {
                        case "Relation":
                        case "Array":
                        case "Object":
                        case "File":
                          acc.push(key);
                          break;
                        default:
                      }
                      return acc;
                    },
                    [
                      "Created At",
                      "updated",
                      "acl",
                      "region",
                      "office",
                      "division",
                      "section",
                      "unit",
                      "cluster",
                    ],
                  )}
                  onClickItem={this.onClickItem.bind(this)}
                />
              </div>
              <hr />
              <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                <Button
                  className="btn btn-light fs-sm"
                  disabled={this.state.submit}
                  onClick={() => {
                    this.setState({ serialNumber: [] });
                    this.props.closeModal();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className="btn btn-primary"
                  progress={this.state.submit}
                  onClick={() => this.presenter.handleClickOk()}
                >
                  OK
                </Button>
              </div>
            </CardView>
          </FloatingForm>

          {/* {this.state.selectModal && (
            <UserModal closeSelectModal={this.closeSelectModal.bind(this)} />
          )} */}
        </>
      </>
    );
  }
}
